module.exports = (s) => {
  return {
    // 素材类别
    type: {
      type: 'select',
      props: {
        placeholder: '请选择素材类别',
        clearable: false,
      },
      on: {
        change: (val) => {
          s.material_format_list_params['type'] = val;
          s.getMaterialFormatList(s.material_format_list_params);
        },
      },
      options: [{
        label: '图片',
        value: 1,
      },
      {
        label: '视频',
        value: 2,
      },
      {
        label: '落地页',
        value: 3,
      },
      {
        label: '组图',
        value: 4,
      }],
      value: null,
    },
  };
};

